<template>
  <div>
    <div class="shizi"  v-if="$conFun.clientWidth() > 768">
      <div class="pageWD">
        <div class="teacherbox">
          <el-carousel
            indicator-position="outside"
            @change="changeMe"
            ref="carousel"
            autoplay
            arrow="always"
            :interval="4000"
          >
            <el-carousel-item v-for="(item, index) in swiperList" :key="index">
              <div class="flex-sb" style="width: 1050px">
                <img
                  src="http://h5.shihua.com/static/yunxue/dd.png?v=1"
                  style="width: 444px; height: 555px"
                />
                <div style="padding-left: 110px">
                  <div
                    class="f36 c3"
                    style="font-weight: 700; padding: 100px 0 25px 0"
                  >
                    姜岚昕
                  </div>
                  <div class="f16 c3 dsbg">云学科技导师</div>
                  <div
                    class="f16 c3"
                    style="line-height: 24px; padding: 30px 0px 40px 0"
                  >
                    2001年创办世华公司，专注管理教育领域20余年。他曾出版《增 长新思维》、《掌控权》、《社会企业家精神》、《领导解放，企 业重生》、《文化要软，制度要硬》等十余部著作，累计发行量超 过300万册，影响人群超过上千万。他也是新浪微博、今日头条百 万级粉丝的大V，他持续笔耕不缀的贡献管理智慧，每年为更多求 知的人带来受益。
                  </div>
                  <!-- <div class="smore">
                    查看详情
                    <img
                      src="http://h5.shihua.com/static/yunxue/smore.png"
                      style="width: 14px"
                    />
                  </div> -->
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div class="caritembox" ref="personWrap">
          <div ref="personTab">
            <div
              v-for="(item, index) in swiperList"
              :key="index"
              :class="
                swiperIndex == index ? 'caritemCurrent caritem' : 'caritem'
              "
              @click="setActiveItem(index)"
              :id="'caritemCurrent' + index"
            >
             <div> <img src="http://h5.shihua.com/static/yunxue/dd.png" /></div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="shizi"  v-else style="padding-bottom:0">
     
        <div class="teacherbox">
          <el-carousel
            indicator-position="outside"
            @change="changeMe"
            ref="carousel"
            autoplay
            arrow="always"
            :interval="4000"
          >
            <el-carousel-item v-for="(item, index) in swiperList" :key="index">
              <div>
                <img
                  src="http://h5.shihua.com/static/yunxue/dd.png?v=1"
                  style="width:200px;margin:0 auto"
                />
                <div style="padding:0 20px" >
                  <div
                    class="f36 c3"
                    style="font-weight: 700; "
                  >
                    姜岚昕
                  </div>
                  <div class="f16 c3 dsbg">云学科技导师</div>
                  <div
                    class="f16 c3"
                    style="line-height: 30px; "
                  >
                    2001年创办世华公司，专注管理教育领域20余年。他曾出版《增 长新思维》、《掌控权》、《社会企业家精神》、《领导解放，企 业重生》、《文化要软，制度要硬》等十余部著作，累计发行量超 过300万册，影响人群超过上千万。他也是新浪微博、今日头条百 万级粉丝的大V，他持续笔耕不缀的贡献管理智慧，每年为更多求 知的人带来受益。
                  </div>
                 
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
       
     
    </div>

  </div>
</template>
<script>
import BetterScroll from "better-scroll";
export default {
  props: ["swiperList"],
  data() {
    return {
      swiperIndex: 0,
      lens: null,
    };
  },
  watch: {
    swiperIndex: function () {
      var id = "caritemCurrent" + this.swiperIndex;
      this.scrollToMe(id);
    },
  },
  updated() {
    this.lens = this.swiperList.length;
    this.$nextTick(() => {
      let timer = setTimeout(() => {
        if (timer) {
          clearTimeout(timer);
          this.personScroll();
        }
      }, 0);
    });
  },
  methods: {
    scrollToMe(ID) {
      let a = document.getElementById(ID);
      this.scroll.scrollToElement(a, 300, 0, true, "easing");
    },
    personScroll() {
      var width = 200 * this.lens;
      this.$refs.personTab.style.width = width + "px";
      // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BetterScroll(this.$refs.personWrap, {
            movable: true,
            zoom: true,
            startX: 0,
            click: true,
            scrollX: true,
            // 忽略竖直方向的滚动
            scrollY: false,
            eventPassthrough: "vertical",
          });
        } else {
          this.scroll.refresh();
        }
      });
    },
    setActiveItem(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    changeMe(e) {
      this.swiperIndex = e;
    },
  },
};
</script>
<style scoped>
.caritembox {
 
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 1200px;
  position: relative;
  top:-140px;
  z-index: 999999999999;
  /* display:flex */
}
.caritembox::-webkit-scrollbar {
  display: none;
}
.caritem {
 padding:0 25px;
  display: inline-block;
  position: relative;
}
.caritem div{
  width: 184px;
  height: 137px;
  
}
.caritem img {
  width: 154px;
  height: 115px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.caritemCurrent img {
  width: 184px;
  height: 137px;
  border: 1px solid #ccc;
  border-radius: 8px;
  position: absolute;
  top:0;
  left:20px
}
.caritem div:last-child {
  color: #babed1;
  width: 180px;
  overflow: hidden;
}
.caritem div:first-child {
  padding-top: 15px;
  color: #babed1;
}
.caritem div {
  padding: 0 20px;
}
.caritemCurrent {
  background: transparent;
}
.caritemCurrent div:last-child {
  color: #fff;
}
.caritemCurrent div:first-child {
  color: #fff;
}
>>> .el-carousel__container {
  height: 555px;
}
>>> .el-carousel__button {
  width: 200px;
  height: 120px;
  margin: 0;
  padding: 0;
}
>>> .el-carousel__indicator--horizontal {
  padding: 0;
  margin-top: 20px;
  display: none;
}

.cartext .fleft {
  width: 386px;
  height: 446px;
  background: #fff;
}
.cartext .rq {
  width: 386px;
  height: 113px;
  background: #2a579e;
  text-align: center;
  line-height: 113px;
  color: #fff;
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue